import constants from './constants';

const setInfoSystem = (values) => (dispatch) => {

  dispatch({
    type: constants.INFO_SYSTEM,
    payload: values,
  });

};

const setGeneralInfo = (values) => (dispatch) => {

  dispatch({
    type: constants.GENERAL_INFO,
    payload: values,
  });

};

const setGeneralStatistics = (values) => (dispatch) => {

  dispatch({
    type: constants.GENERAL_STATISTICS,
    payload: values,
  });

};

const setTotalStatistics = (values) => (dispatch) => {

  dispatch({
    type: constants.TOTAL_STATISTICS,
    payload: values,
  });

};

const setGraphAttribute = (values) => (dispatch) => {

  dispatch({
    type: constants.GRAPH_INITIAL_DATA,
    payload: values,
  });

};

const setGraphBattery = (values) => (dispatch) => {

  dispatch({
    type: constants.GRAPH_BATTERY_DATA,
    payload: values,
  });

};

const setGraphBatteryBoxPLot = (values) => (dispatch) => {

  dispatch({
    type: constants.GRAPH_BATTERY_DATA_BOX_PLOT,
    payload: values,
  });

};

const setDeviceId = (values) => (dispatch) => {

  dispatch({
    type: constants.DEVICE_ID,
    payload: values,
  });

};

const setConsultAttribute = (values) => (dispatch) => {

  dispatch({
    type: constants.CONSULT_ATTRIBUTE,
    payload: values,
  });

};

const setConsultAttributeBattery = (values) => (dispatch) => {

  dispatch({
    type: constants.CONSULT_ATTRIBUTE_BATTERY,
    payload: values,
  });

};

const setTypeConsultBattery = (values) => (dispatch) => {

  dispatch({
    type: constants.TYPE_CONSULT_BATTERY,
    payload: values,
  });

};

const setTypeConsultBatteryBoxPlot = (values) => (dispatch) => {

  dispatch({
    type: constants.TYPE_CONSULT_BATTERY_BOX_PLOT,
    payload: values,
  });

};

const setLoadingGraphAttribute = (values) => (dispatch) => {

  dispatch({
    type: constants.LOADING_ATTRIBUTE_GRAPH,
    payload: values,
  });

};

const setLoadingGraphBattery = (values) => (dispatch) => {

  dispatch({
    type: constants.LOADING_BATTERY_GRAPH,
    payload: values,
  });

};

const setLoadingGraphBatteryBoxPlot = (values) => (dispatch) => {

  dispatch({
    type: constants.LOADING_BATTERY_GRAPH_BOX_PLOT,
    payload: values,
  });

};

const setLoadingInfoSystem = (values) => (dispatch) => {

  dispatch({
    type: constants.LOADING_INFO_SYSTEM,
    payload: values,
  });

};

const setLoadingDataTable = (values) => (dispatch) => {

  dispatch({
    type: constants.DATA_DEVICES_TABLE,
    payload: values,
  });

};

const setAllInvertersData = (values) => (dispatch) => {

  dispatch({
    type: constants.ALL_INVERTERS_DATA,
    payload: values,
  });

};

function setDeleteInverterData(deleteInverter) {

  // eslint-disable-next-line func-names
  return (dispatch, getState) => {

    const { telemetry } = getState();
    const { allInverters } = telemetry;
    const indexTarget = allInverters.filter((data) => data.id !== deleteInverter.id);
    dispatch({
      type: constants.DELETE_INVERTER_DATA,
      payload: indexTarget,
    });

  };

}

const setEdgeNames = (values) => (dispatch) => {

  dispatch({
    type: constants.EDGE_NAMES,
    payload: values,
  });

};

const setConsultAttributeBatteryBoxPlot = (values) => (dispatch) => {

  dispatch({
    type: constants.CONSULT_ATTRIBUTE_BATTERY_BOX_PLOT,
    payload: values,
  });

};

// MIGUEL
const setInfoBusinessType = (values) => (dispatch) => {

  dispatch({
    type: constants.INFO_BUSINESS_TYPE,
    payload: values,
  });

};

const setAllDevicesData = (values) => (dispatch) => {

  dispatch({
    type: constants.ALL_DEVICES_DATA,
    payload: values,
  });

};

const setGeneralDeviceInfo = (values) => (dispatch) => {

  dispatch({
    type: constants.GENERAL_DEVICE_INFO,
    payload: values,
  });

};

export default {
  setAllInvertersData,
  setLoadingDataTable,
  setGeneralInfo,
  setGeneralStatistics,
  setGraphAttribute,
  setGraphBattery,
  setInfoSystem,
  setDeviceId,
  setConsultAttribute,
  setTypeConsultBattery,
  setLoadingGraphAttribute,
  setLoadingGraphBattery,
  setEdgeNames,
  setTotalStatistics,
  setGraphBatteryBoxPLot,
  setLoadingGraphBatteryBoxPlot,
  setTypeConsultBatteryBoxPlot,
  setDeleteInverterData,
  setConsultAttributeBattery,
  setConsultAttributeBatteryBoxPlot,

  // Miguel
  setAllDevicesData,
  setGeneralDeviceInfo,
  setLoadingInfoSystem,
  setInfoBusinessType,
};
